export const navigationGroups = [
  {
    key: 'NAV_OVERVIEW',
    links: [
      {
        key: 'NAV_DASHBOARD',
        route: 'dashboard',
        hash: '#overview',
        icon: 'fas fa-chart-pie',
        paths: ['/dashboard', '/home'],
      },
    ],
  },
  {
    key: 'OPERATIONS',
    links: [
      { key: 'AGENT_TITLE', route: 'agent', icon: 'fas fa-comments', paths: ['/agent'], role: 'mainAdmin' },
      {
        key: 'TENANT',
        plural: true,
        route: 'tenants',
        icon: 'fas fa-building',
        paths: ['/tenants', '/carriers'],
      },
      {
        key: 'SUPPORT_TICKET',
        plural: true,
        route: 'supportTickets',
        icon: 'fas fa-headset',
        paths: ['/support-tickets'],
      },
      {
        key: 'BROADCAST_NOTIFICATION',
        route: 'notificationsCompose',
        icon: 'fas fa-bullhorn',
        paths: ['/notifications'],
      },
    ],
  },
  {
    key: 'NAV_PROVIDERS',
    links: [
      {
        key: 'PROVIDER',
        plural: true,
        route: 'providers',
        icon: 'fas fa-truck',
        paths: ['/providers'],
      },
      {
        key: 'PROVIDER_VERIFICATION',
        route: 'providerVerifications',
        icon: 'fas fa-shield-halved',
        paths: ['/provider-verifications'],
        role: 'mainAdmin',
      },
      {
        key: 'PROVIDER_HEALTH',
        route: 'providerApisPanel',
        icon: 'fas fa-heart-pulse',
        paths: ['/provider-apis-panel'],
      },
    ],
  },
  {
    key: 'NAV_REPORTS',
    links: [
      {
        key: 'TRACKING_DASHBOARD',
        route: 'trackingDashboard',
        icon: 'fas fa-route',
        paths: ['/tracking-dashboard'],
        role: 'developer',
      },
      {
        key: 'OLD_SHIPMENTS_REPORT',
        route: 'oldShipmentsReport',
        icon: 'fas fa-clock',
        paths: ['/old-shipments-report'],
        role: 'mainAdmin',
      },
      {
        key: 'PROVIDER_REPORT_AUDITS',
        route: 'providerReportAudits',
        icon: 'fas fa-file-invoice-dollar',
        paths: ['/provider-report-audits'],
        role: 'mainAdmin',
      },
      {
        key: 'AI_ANALYTICS',
        route: 'aiAnalytics',
        icon: 'fas fa-wand-magic-sparkles',
        paths: ['/ai-analytics'],
        role: 'developer',
      },
    ],
  },
  {
    key: 'NAV_SYSTEM',
    links: [
      { key: 'MAIN_ADMINS_TITLE', route: 'mainAdmins', icon: 'fas fa-user-shield', paths: ['/main-admins'], role: 'developer' },
      {
        key: 'VALIDATOR',
        plural: true,
        route: 'validators',
        icon: 'fas fa-list-check',
        paths: ['/validators'],
        role: 'developer',
      },
      {
        key: 'REQUEST_LOGS',
        route: 'requestLogs',
        icon: 'fas fa-terminal',
        paths: ['/request-logs'],
        role: 'developer',
      },
      {
        key: 'SYSTEM_SETTING',
        plural: true,
        route: 'systemSettings',
        icon: 'fas fa-gear',
        paths: ['/system-settings'],
        role: 'developer',
      },
    ],
  },
]

export function matchesNavigation(link, path) {
  return link.paths.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`)
  )
}
